<template>
	<div id="PageCar">
		<div class="container content-car">
			<Title :title="'Select the vehicle'"></Title>

			<div class="row">
				<div class="col wrapper-rounded-content">
					<div class="bg-blue-multiply rounded-corners"></div>

					<div v-if="groups && prices" class="row justify-content-center align-items-center">
						<div class="col-10 col-offset-1 col-md-12 col-md-offset-0">
							<OwlCarousel
								
							:responsive="carousel_responisve"

							:dots="false"
							:nav="true"
							:loop="false"
							:rewind="true"
							:items="3">
								<div
								@click="setCarGroup"
								v-for="carGroup in sortedGroups"
								:is="(carGroup.groupKey ? 'CarGroupCard' : 'CarCard')"
								:key="carGroup.groupKey"
								:carGroup="carGroup"
								:price="prices_by_key[carGroup.groupKey]"
								:groupDetails="car_by_key[carGroup.groupKey]"
								:groupAvaible="carAvail_by_key[carGroup.groupKey]"
								v-if="prices_by_key[carGroup.groupKey] > 0"
								></div>
							</OwlCarousel>
						</div>
					</div>

					<div v-else class="loading">
						<span>{{ $t('Loading') }}</span>
					</div>
				</div>
			</div>

			<!-- <div class="row">
				<div class="col-12 text-center">
					<button type="button" class="btn btn-primary btn-wp">
						{{ $t('Selection and next step') }}
					</button>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex'

import forEach 			from 'lodash/forEach';
import sortBy 			from 'lodash/sortBy';

export default {
	name: 'PageCar',
	data() {
		return {
			carousel_responisve: {
				0: {
					margin: 15,
					items: 1,
					center: false,
					nav: true
				},
				768: {
					margin: 15,
					items: 2,
					center: false,
					nav: true
				},
				1200: {
					items: 3,
					center: false,
					nav: true
				}
			},
			prices: false,
			prices_by_key: {},
			car_by_key: {},
			carAvail_by_key: {},
		}
	},
	computed: {

		sortedGroups(){
			var self = this;
			return sortBy(this.groups,
				function(o){
					if(self.prices_by_key[o.groupKey] === 0) return Number.MAX_SAFE_INTEGER;
					return self.prices_by_key[o.groupKey];
				});
		},

		...mapGetters('orm', [
			'groups',
	    ]),

		...mapGetters('orm/reservation', [
			'station',
			'startdate',
			'enddate',
			'rentaltype',
	    ])
	},
	mounted(){
		var self = this;

		console.log('startdate: ',this.startdate);
		console.log('enddate: ',this.enddate);
		console.log(this.rentaltype)

		if(!this.station){
			this.$router.push({ name: 'PagePlace', params: this.$route.params}); return;
		}
		if(!this.startdate){
			this.$router.push({ name: 'PageTime', params: this.$route.params}); return;
		}
		if(!this.enddate){
			this.$router.push({ name: 'PageTime', params: this.$route.params}); return;
		}

		this.$store.dispatch('orm/GET_GROUPS')
		.then(groups => {
			self.$store.dispatch('orm/GET_AVAILABLE_GROUPS', {
				station: this.station,
				startdate:this.startdate,
				enddate: this.enddate,
				priceList: this.rentaltype,
			}).then(res => {
				// self.$store.dispatch('orm/GET_AVAILABLE_GROUPS')
				self.prices = res;
				self.prices_by_key = {};
				self.billkey_by_key = {};
				self.car_by_key = {};
				self.carAvail_by_key = {};

				forEach(this.prices, (obj, index) => {

					if(obj.group && obj.rates[0].priceVat){
						self.prices_by_key[obj.group] = obj.rates[0].priceVat;
						self.prices_by_key[obj.group] = obj.rates[0].priceVat;
						
					} else {
						self.prices_by_key[obj.group] = 0;
					}
					self.billkey_by_key[obj.group] = obj.rates[0].billKey;
					self.car_by_key[obj.group] = obj.rates[0];
					self.carAvail_by_key[obj.group] = obj.available;
				})

			}).catch(err => { this.$store.commit("core/ADD_ERROR", err); });
		}).catch(err => { this.$store.commit("core/ADD_ERROR", err); })

		// this.$api
		// .post('/api/carsharing/reservation', {
		// 	startStationKey: this.station,
		// 	startDate: this.formatDate(this.startdate),
		// 	endDate: this.formatDate(this.enddate),
		// })
		// .then(response => {
		// 	console.log(response);
		// 	self.$store.commit('orm/SET_STATIONS', response.data);
		// }).catch(err =>{
		// 	console.error(err);
		// });



		// this.$api
		// .post('/api/carsharing/reservate', {
		// 	startStationKey: this.station,
		// 	startDate: this.formatDate(this.startdate),
		// 	endDate: this.formatDate(this.enddate),
		// })
		// .then(response => {
		// 	console.log(response);
		// 	self.$store.commit('orm/SET_STATIONS', response.data);
		// }).catch(err =>{
		// 	console.error(err);
		// });
	},
	methods: {
		formatDate(date){
			// Y-m-d H:i
			return date.getFullYear() +'-'+ date.getMonth() +'-'+ date.getDate() +' '+ date.getHours() +':'+ date.getMinutes();
		},
		setCarGroup(carGroup,ev){
			console.log(ev)
			console.log(carGroup)
			console.log(this.billkey_by_key[carGroup.groupKey]);
			carGroup.price = this.prices_by_key[carGroup.groupKey];
			carGroup.billKey = this.billkey_by_key[carGroup.groupKey];
			this.$store.commit('orm/reservation/SET_CAR', carGroup);
			this.$router.push({
				name: 'PageVoucher', params: {
				cargroup: carGroup.groupKey
			}});
		}
	}
}
</script>


<style lang="scss">
#PageCar .owl-item {
	padding: 1em;
}
.loading {
	position: relative;
	display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    vertical-align: middle;
    color: #fff;
    font-size: 2rem;
    font-weight: 300;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/PageCar.vue